module.exports = __webpack_public_path__ + "img/recruit_img.0687fc40.svg";